module.exports = __webpack_public_path__ + "img/logo.a546f6c9.png";